import Swiper from 'swiper'
import { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules'

export default {
  init: () => {
    const el = document.querySelector('.page-header-media-slider')
    const container = el.querySelector('.swiper')
    const numSlides = el.querySelectorAll('.swiper-slide').length

    if (numSlides > 1) {
      const opts = {
        modules: [A11y, Autoplay, EffectFade],
        autoplay: {
          delay: 4000,
        },
        effect: 'fade',
        loop: true,
        speed: 1000,
      }

      if (el.querySelector('.slider-controls')) {
        opts.modules.push(Navigation)
        opts.modules.push(Pagination)
        opts.navigation = {
          nextEl: el.querySelector('.slider-button-next'),
          prevEl: el.querySelector('.slider-button-prev'),
        }
        opts.pagination = {
          el: el.querySelector('.slider-pagination'),
          type: 'fraction',
        }
      }

      new Swiper(container, opts)
    }
  },
}
